<template>
  <div class="container-wrapper">
    <div class="container-header" :style="{ backgroundColor: backgroundColor, color: textColor }">
      <span class="container-title">{{ title }}</span>
      <div v-if="$slots.actions" class="container-actions">
        <slot name="actions" />
      </div>
    </div>
    <div class="container-content" :style="{ paddingTop: backgroundColor === 'white' ? '9px' : '24px' }">
      <p v-if="introduction" class="container-introduction">
        {{ introduction }}
      </p>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "Container",
  props: {
    title: {
      type: String,
      required: true,
    },
    introduction: {
      type: String,
      default: "",
    },
    backgroundColor: {
      type: String,
      default: "var(--grey-light-color)",
    },
    textColor: {
      type: String,
      default: "var(--dark-color)",
    },
  },
};
</script>

<style scoped>
.container-wrapper {
  width: 100%;
  border: 1px solid var(--border-grey-color);
  border-radius: 8px;
  margin-bottom: 24px;
  overflow: hidden;
}

.container-wrapper:last-child {
  margin-bottom: 0;
}

.container-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
  font-size: 1.2rem;
  font-weight: 500;
}

.container-title {
  word-break: break-word;
  font-size: 1.2rem !important;
  font-weight: 500 !important;
}

.container-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.container-content {
  padding: 0 24px 24px 24px;
}

.container-introduction {
  padding-bottom: 16px;
  margin-top: -4px;
  color: var(--grey-color);
  font-size: 0.9rem;
}

:deep(.v-row) {
  display: flex;
  align-items: flex-end;
}

:deep(.v-col) {
  padding-top: 4px;
  padding-bottom: 12px;
}
</style>
